import { useEffect, useState } from 'react';
import { AlertTriangle } from '../../lib/icons';
import { fetchReferenceBourse } from '../../lib/bourse';

// Encart CONSULTATIF : n'alimente aucun champ de prix et n'écrit rien.
export const ReferenceMarche = () => {
  const [ref, setRef] = useState(null);

  useEffect(() => {
    let vivant = true;
    fetchReferenceBourse().then((r) => vivant && setRef(r));
    return () => {
      vivant = false;
    };
  }, []);

  if (!ref) return null;

  return (
    <div data-testid="reference-marche" className="flex flex-wrap items-center gap-x-6 gap-y-2 border border-slate-200 border-l-4 border-l-slate-900 bg-white px-4 py-3">
      <div>
        <p className="text-[10px] font-bold uppercase tracking-[0.1em] text-slate-500">Référence de marché — indicative</p>
        <p className="font-data text-sm font-bold text-slate-900">
          Extra <span data-testid="reference-extra">{ref.label_extra}</span> · Lampante{' '}
          <span data-testid="reference-lampante">{ref.label_lampante}</span> TND/kg
        </p>
      </div>
      <p className="font-data text-[11px] text-slate-500">
        {ref.contributors} contributeur(s) sur {ref.window_hours} h
        {ref.provisional && (
          <span data-testid="reference-provisoire" className="ml-1 border border-amber-300 bg-amber-50 px-1 font-bold uppercase tracking-[0.08em] text-amber-800">
            provisoire
          </span>
        )}
      </p>
      <p className="flex items-start gap-1 text-[11px] text-slate-500">
        <AlertTriangle size={12} className="mt-0.5 shrink-0" />
        Aucun effet sur le CMP, les achats, les stocks, les factures ni les prix saisis — à titre d’information.
      </p>
    </div>
  );
};
